import { render, staticRenderFns } from "./RemoteTable.vue?vue&type=template&id=9bb42d72&"
import script from "./RemoteTable.vue?vue&type=script&lang=js&"
export * from "./RemoteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports